module.exports = __webpack_public_path__ + "img/Multihull.88e94821.svg";